
import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { SpinnerService } from './services/spinner.service';
import { ModalConfig, ModalService } from './services/modal.service';
import { PermissionService } from './api-services/Permission/permission.service';
import { asapScheduler, filter, observeOn, Subscription } from 'rxjs';
import { AuthService } from './api-services/AdminHRService/Login/auth.service';

declare const KTMenu: any;
declare var KTThemeMode: any;
declare var KTAppSidebar: any;
declare var KTComponents: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  standalone: false,
  styleUrl: './app.component.css',

})
export class AppComponent implements OnInit, OnDestroy {
  title = 'magicbucket';
  currentUrl = '';

  private routerSub?: Subscription;
  private spinnerSub?: Subscription;
  private modalSub?: Subscription;

  isLoading = false;
  isLoggedIn = false;
  modalConfig: ModalConfig | null = null;

  constructor(
    public spinnerService: SpinnerService,
    private modalService: ModalService,
    private router: Router,
    private permissionService: PermissionService,
    private authService: AuthService
  ) {}

  ngOnInit(): void {
    // Requests started while child views initialize must not change an already checked binding.
    this.spinnerSub = this.spinnerService.isLoading$
      .pipe(observeOn(asapScheduler))
      .subscribe(value => {
        this.isLoading = value;
      });

    this.modalSub = this.modalService.modal$.subscribe(config => {
      this.modalConfig = config;
    });

    // APP_INITIALIZER restores authentication before this component is created.
    this.permissionService.restore();
    this.isLoggedIn = this.authService.isAuthenticated();

    this.routerSub = this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((e: NavigationEnd) => {
        this.currentUrl = e.urlAfterRedirects;
        this.isLoggedIn = this.authService.isAuthenticated();

        setTimeout(() => {
          if (typeof KTComponents !== 'undefined') {
            KTComponents.init();
          }

          if (typeof KTMenu !== 'undefined') {
            KTMenu.createInstances();
          }

          if (typeof KTAppSidebar !== 'undefined') {
            KTAppSidebar.init();
          }
        }, 100);
      });
  }

  ngOnDestroy(): void {
    this.routerSub?.unsubscribe();
    this.spinnerSub?.unsubscribe();
    this.modalSub?.unsubscribe();
  }

  closeModal(): void {
    this.modalService.close();
  }

  isCandidateLoginPage(): boolean {
    return this.currentUrl === '/CandidateSignIn';
  }

  isNormalLoginPage(): boolean {
    return this.currentUrl === '/SignIn';
  }
}
